import { ZERO, parseDecimal } from '@insio/decimal';
import type { InternalVatRow } from './vat-summary-types';

type RowField = 'netAmount' | 'vatAmount' | 'vatRate';

const parseRate = (raw: string): number => {
  const normalized = (raw ?? '').replace(/\s/g, '').replace(',', '.');
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Synchronously apply pending raw cell values to a row array.
 * Must be used instead of relying on `setVatRows` having flushed
 * before imperative reads (e.g. in handleSave, addCustomRow).
 */
export function applyRawValues(
  rows: InternalVatRow[],
  rawValues: Record<string, string>
): InternalVatRow[] {
  const next = [...rows];
  for (const [k, raw] of Object.entries(rawValues)) {
    const dashIdx = k.indexOf('-');
    const idx = parseInt(k.slice(0, dashIdx), 10);
    const f = k.slice(dashIdx + 1) as RowField;
    if (isNaN(idx) || idx < 0 || idx >= next.length) continue;
    if (f === 'vatRate') {
      next[idx] = { ...next[idx], vatRate: parseRate(raw) };
    } else {
      next[idx] = { ...next[idx], [f]: parseDecimal(raw) ?? ZERO };
    }
  }
  return next;
}
